import { C, P0, S, abs, arc, fillAt, max, rotPts, sq } from '../../geometry';

export const bee = {
  name: 'Bee',
  colors: ['#E3A008', '#161616'],
  draw(m, t) {
    let fl = 14 * S(t * 16),
      ant = 0,
      pose = P0();
    pose.ty = 1.5 * S(t * 2);
    if (m === 'happy') {
      fl = 30 * S(t * 30);
      ant = 3 * S(t * 12);
      pose.ty = -3 * abs(S(t * 6));
    }
    // Thinking: hovers round a figure-eight on a blur of wings.
    if (m === 'thinking') {
      fl = 28 * S(t * 34);
      pose.tx = 7 * S(t * 1.8);
      pose.ty = -1 + 3.5 * S(t * 3.6);
      pose.rot = 5 * C(t * 1.8);
      ant = 3 * S(t * 3.6);
    }
    if (m === 'talking') {
      fl = 14 * S(t * 20);
      ant = 3 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      fl = -24 + 4 * S(t * 30);
      ant = -5;
      pose.ty = -3;
    }
    if (m === 'paused') {
      fl = -8;
      ant = 7;
      pose.ty = 3;
      pose.sy = 0.95;
    }
    const cx = 50,
      cy = 60,
      hw = 25,
      hh = 17,
      p = 2.6,
      half = (x) =>
        hh * Math.pow(max(0, 1 - Math.pow(abs(x - cx) / hw, p)), 1 / p);
    const loop = (ox, oy, rx, ry, tilt) =>
      rotPts(
        arc(ox, oy, 1, -90, 270, 13).map(([x, y]) => [
          ox + (x - ox) * rx,
          oy + (y - oy) * ry,
        ]),
        ox,
        oy,
        tilt
      );
    const wingL = rotPts(loop(52, 32, 6.5, 10, -28), 56, 44, -fl),
      wingR = rotPts(loop(65, 32, 6.5, 10, 24), 60, 44, fl);
    const stripe = (x) => [
      [x, cy - half(x)],
      [x, cy + half(x)],
    ];
    return {
      strokes: [
        { c: 'b', pts: wingL, n: 18 },
        { c: 'b', pts: wingR, n: 18 },
        {
          c: 'b',
          pts: [
            [35, 47],
            [31, 37],
            [26, 34 + ant],
          ],
        },
        {
          c: 'b',
          pts: [
            [43, 45],
            [43, 34],
            [39, 29 + ant],
          ],
        },
        {
          c: 'b',
          pts: [
            [76, 60],
            [83, 62],
          ],
        },
        { c: 'a', pts: sq(cx, cy, hw, hh, p), n: 30 },
        { c: 'b', pts: stripe(59) },
        { c: 'b', pts: stripe(68) },
      ],
      eyes: { x: 41, y: 59 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 5),
};
